import { globalWindow, document } from '@emico/ssr-utils'

const writeLoadedChunksToDocument = () => {
  if (!document) {
    return
  }
  const initialState = `window.preloadChunks=${JSON.stringify(
    globalWindow?.activeChunks || [],
  )}`
  const script = document.createElement('script')
  script.id = 'preload-chunks'
  script.textContent = initialState
  const head = document?.getElementsByTagName('head')[0]
  head.appendChild(script)
}

export default writeLoadedChunksToDocument
